export default __webpack_public_path__ + "static/media/disabled-cash.edb0bdbf.svg";